exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open[data-v-6e97f800]{color:#6fa551}.closed[data-v-6e97f800]{color:crimson}.waiting-list[data-v-6e97f800]{color:#ecb618}span[data-v-6e97f800]{padding-left:2rem;font-size:.7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e97f800","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/RegistrationCategories/Tickets/Utility/StatusBadge.vue
// module id = 2478
// module chunks = 1